import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { addDays, format } from 'date-fns';
import { useAuth } from '../../contexts/AuthContext';
import { usePost } from './../../apis/ApiRequests';
import { dateToString } from '../../utils/Library';
import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper, Box } from '@mui/material';
import { facilityData } from '../../Store';

const BidHistoryMonitor = () => {

	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const { authInfo }   = useAuth();
    const facilityCode   = authInfo.facilityCode ? authInfo.facilityCode : facilityData.facilityCode;
    const facilityName   = authInfo.facilityName;
    const userId         = authInfo.userId ? authInfo.userId : 'Signage';
    const luserName      = authInfo.userName;
    const authority      = authInfo.authority;
    const today          = format(addDays(new Date(), 0), 'yyyy-MM-dd');
    const navigate       = useNavigate();

	//-----------------------------------------------
    // initialize - useState
	//-----------------------------------------------
    const [ entryDate,   setEntryDate   ] = useState(today);
    const [ historyList, setHistoryList ] = useState([]);
    
	//===============================================
	// API
	//===============================================
    //-----------------------------------------------
    // API - searchDataByBidHistory / Signage
    //-----------------------------------------------
    const { response : searchData_history_res, post:searchData_history_post } = usePost();
    const searchData_history = async () => {
        const numericDate = dateToString(entryDate);
        const postData = {
            'className'    : 'mch.models.table.Signage',
            'methodName'   : 'searchDataByBidHistory',
            'facilityCode' : facilityCode,
            'userId'       : userId,
            'entryDate'    : numericDate,
        }
        await searchData_history_post(postData);
    };
	//===============================================
	// useEffect
	//===============================================
	//-----------------------------------------------
    // useEffect - ロード時の設定
	//-----------------------------------------------
    useEffect(() => {

        searchData_history();
        
        // 30秒ごとにデータを更新するタイマーを設定
        const interval = setInterval(timer, 10000);
    
        // コンポーネントのアンマウント時にタイマーをクリア
        return () => clearInterval(interval);
        
    },[]);
    const timer = () => {
        searchData_history();
    };
	//-----------------------------------------------
    // useEffect - searchDataByBidHistory / Signage
	//-----------------------------------------------
    useEffect(() => {
        setHistoryList([]);
        if (searchData_history_res) {
            setHistoryList(searchData_history_res.Data);
        }
    }, [searchData_history_res]);

	//===============================================
	// eventHandler
	//===============================================
    const handleClick_header = () => {
        userId == 'Signage' ? navigate('/') : navigate('/signageMenu');
    };
    //===============================================
    // Css
    //===============================================
    const bidHistoryMonitor_table_cell_header = {
        backgroundColor: '#fff', color: '#005243', borderRight:'3px solid #005243', padding:'5px',  fontSize:'2em', fontWeight:'bold', height:'2em',
        borderBottom:'3px solid #005243', borderTop:'3px solid #005243'
    };
    const bidHistoryMonitor_table_cell = {
        padding:'5px', fontSize:'2em', fontWeight:'bold', 
        backgroundColor: '#005243', color: '#fff', borderBottom:'3px solid #fff', borderRight:'3px solid #fff'
    };
    
    //-----------------------------------------------
	// 正規表現でセパレート
    //-----------------------------------------------
	const separate = (num) => {
    	return String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
	};
	//===============================================
	// JSXのレンダー
	//===============================================
    return (
        <>
            <div className='bidHistoryMonitor signageContens' style={{ height: '100vh',overflow:'hidden' }}>
                <div  onClick={() => handleClick_header()} style={{backgroundColor:'#fff', paddingTop:'0.5em', paddingBottom:'0.5em'}}>
                    <div>
                        <span style={{fontSize:'2em', fontWeight:'bold', color:'#005243'}}>【落札情報】</span>
                    </div>
                    <div>
                        <span style={{fontSize:'2em', fontWeight:'bold', color:'#005243'}}>{ today }</span>
                    </div>
                </div>
                <div>
                    <TableContainer component={Paper} style={{border:'none', backgroundColor:'#efefef', marginTop:'0'}}>
                        <Table stickyHeader sx={{ minWidth: '500px', padding:0 }} size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={ bidHistoryMonitor_table_cell_header } style={{ width: '55vh', borderLeft:'3px solid #005243' }} align='center'>品名 / 漁法</TableCell>
                                    <TableCell sx={ bidHistoryMonitor_table_cell_header } style={{ width: '13vh' }} align='center'>水槽</TableCell>
                                    <TableCell sx={ bidHistoryMonitor_table_cell_header } style={{ width: '15vh' }} align='center'>Kg数</TableCell>
                                    <TableCell sx={ bidHistoryMonitor_table_cell_header } style={{ width: '10vh' }} align='center'>数量</TableCell>
                                    <TableCell sx={ bidHistoryMonitor_table_cell_header } style={{ width: '10vh' }} align='center'>単位</TableCell>
                                    <TableCell sx={ bidHistoryMonitor_table_cell_header } style={{ width: '10vh' }} align='center'>コード</TableCell>
                                    <TableCell sx={ bidHistoryMonitor_table_cell_header } style={{ width: '30vh' }} align='center'>屋号</TableCell>
                                    <TableCell sx={ bidHistoryMonitor_table_cell_header } style={{ width: '15vh' }} align="center">入札単価</TableCell>
                                    <TableCell sx={ bidHistoryMonitor_table_cell_header } style={{ width: '15vh' }} align="center">落札数量</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                            {historyList.map((row, index) => (
                                <TableRow key = { row.id } >
                                    <TableCell sx={ bidHistoryMonitor_table_cell } align="left" style={{borderLeft:'3px solid #fff'}}>{ row.displayGyoshu }</TableCell>
                                    <TableCell sx={ bidHistoryMonitor_table_cell } align="center">{ row.danbe }</TableCell>
                                    <TableCell sx={ bidHistoryMonitor_table_cell } align="right">{ row.kgSuryo }</TableCell>
                                    <TableCell sx={ bidHistoryMonitor_table_cell } align="right">{ row.suryo }</TableCell>
                                    <TableCell sx={ bidHistoryMonitor_table_cell } align="left">{ row.kgKubunName }</TableCell>
                                    <TableCell sx={ bidHistoryMonitor_table_cell } align="right">{ row.traderCode }</TableCell>
                                    <TableCell sx={ bidHistoryMonitor_table_cell } align="left">{ row.trader }</TableCell>
                                    <TableCell sx={ bidHistoryMonitor_table_cell } align="right">{row.tanka ? separate(row.tanka) + "円" : ""}</TableCell>
                                    <TableCell sx={ bidHistoryMonitor_table_cell } align="right">{ row.entrySuryo }</TableCell>
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>
        </>
    )
}
export default BidHistoryMonitor;